import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  VStack,
  useToast,
  Text,
  Select,
  Card,
  CardHeader,
  CardBody,
  Heading,
} from '@chakra-ui/react';
import { useState } from 'react';
import { sendWelcomeEmail, sendConsentConfirmation, sendConsentRevocationEmail } from '../utils/emailService';

const EmailTest = () => {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [templateType, setTemplateType] = useState('welcome');
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  const handleSendEmail = async () => {
    if (!email || !name) {
      toast({
        title: 'Error',
        description: 'Please fill in all fields',
        status: 'error',
        duration: 3000,
      });
      return;
    }

    setLoading(true);
    try {
      let result;
      switch (templateType) {
        case 'welcome':
          result = await sendWelcomeEmail(email, name);
          break;
        case 'consent':
          result = await sendConsentConfirmation(email, name);
          break;
        case 'revocation':
          result = await sendConsentRevocationEmail(email, name);
          break;
        default:
          throw new Error('Invalid template type');
      }

      if (result.success) {
        toast({
          title: 'Success',
          description: 'Email sent successfully',
          status: 'success',
          duration: 3000,
        });
      } else {
        throw new Error(result.error);
      }
    } catch (error) {
      console.error('Error sending email:', error);
      toast({
        title: 'Error',
        description: error.message,
        status: 'error',
        duration: 5000,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box maxW="800px" mx="auto" py={8}>
      <Card>
        <CardHeader>
          <Heading size="lg">Email Template Test</Heading>
        </CardHeader>
        <CardBody>
          <VStack spacing={6} align="stretch">
            <Text color="gray.600">
              Use this form to test the different email templates. Emails will be sent using
              the configured SendGrid account.
            </Text>

            <FormControl isRequired>
              <FormLabel>Email Address</FormLabel>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="member@example.com"
              />
            </FormControl>

            <FormControl isRequired>
              <FormLabel>Member Name</FormLabel>
              <Input
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="John Doe"
              />
            </FormControl>

            <FormControl isRequired>
              <FormLabel>Template Type</FormLabel>
              <Select
                value={templateType}
                onChange={(e) => setTemplateType(e.target.value)}
              >
                <option value="welcome">Welcome Email</option>
                <option value="consent">Consent Confirmation</option>
                <option value="revocation">Consent Revocation</option>
              </Select>
            </FormControl>

            <Button
              colorScheme="blue"
              onClick={handleSendEmail}
              isLoading={loading}
              loadingText="Sending..."
            >
              Send Test Email
            </Button>
          </VStack>
        </CardBody>
      </Card>
    </Box>
  );
};

export default EmailTest;
